import httpService from '@Utils/httpService';

const baseUrl = 'api/BlobStorage';

export default {
    getLimitsByFacility(facilityId) {
        return httpService.get({
            url: `${baseUrl}/limits/facility/${facilityId}`,
        });
    },
    reportProgress(data) {
        return httpService.post({
            url: `${baseUrl}/download/progress`,
            data
        });
    },
    
}